import { useState } from 'react';

const AgentCTASection = () => {
  const [imgOk, setImgOk] = useState(true);
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative bg-teal-50 rounded-xl p-8 flex flex-col md:flex-row items-center justify-between overflow-hidden">
          {/* Coming soon badge */}
          <span className="absolute top-4 right-4 inline-flex items-center gap-1.5 rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-amber-700">
            <i className="ri-time-line"></i>
            Coming soon
          </span>

          <div className="max-w-2xl">
            <h3 className="text-2xl lg:text-3xl font-bold text-teal-900 mb-3">
              Are You a House or Hostel Agent?
            </h3>
            <p className="text-teal-800">
              Soon you'll be able to list available rooms and hostels on Campus Market and reach thousands of students actively searching for accommodation on campus.
            </p>
          </div>
          <div className="mt-6 md:mt-0 flex flex-col items-center">
            {imgOk && (
              <img
                src="/hostel.jpg"
                alt="Hostel"
                className="w-64 h-40 md:w-72 md:h-48 object-cover rounded-lg shadow-sm border border-teal-100 mb-4"
                style={{
                  WebkitMaskImage:
                    'linear-gradient(to right, transparent, black 12%, black 88%, transparent)',
                  maskImage:
                    'linear-gradient(to right, transparent, black 12%, black 88%, transparent)',
                }}
                onError={() => setImgOk(false)}
              />
            )}
            <button
              type="button"
              disabled
              aria-disabled="true"
              title="This feature is coming soon"
              className="inline-flex items-center px-6 py-3 bg-gray-200 text-gray-500 font-semibold rounded-lg whitespace-nowrap cursor-not-allowed select-none"
            >
              List Rooms & Hostels
              <i className="ri-lock-line ml-2"></i>
            </button>
            <span className="mt-2 text-xs text-teal-700/80">Available soon</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AgentCTASection;
